<template>
  <div>
    <apollo-query v-show='true' :query='getTemplatesQuery'
      :variables='{from, size}'
      fetch-policy='cache-and-network'
      class="h-48 flex flex-row overflow-x-scroll overflow-y-hidden">
      <template v-slot='{ result: { loading, error, data }, isLoading }'>
        <p class="text-white">current {{currentTemplateId}}</p>
        <button v-for='template in (((data||{}).getTemplates||{}).items||[])'
            :key='template.id'
            @click='onTemplate(template)'
            :class='isSelectedClass(template)'
            class='flex-none rounded mx-2 my-1 text-center flex flex-col justify-start w-48 h-48'>

            <img :src='makeImageUrl(template)' class="object-contain w-full w-full h-48" loading="lazy" />


        </button>
      </template>
    </apollo-query>

  </div>
  
</template>
<script>
import { getTemplatesQuery } from '@/gql/Queries.js';
export default {
  inject:['api'],
  props: {
    currentTemplateId:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      getTemplatesQuery,
      from:0,
      size:100
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory:'template',
      eventAction:'openChangeTemplate'
    });
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory:'template',
      eventAction:'closeChangeTemplate'
    });
  },
  methods:{
    isSelectedClass(template) {
      if (template.id === this.currentTemplateId) {
        return 'bg-blue-400'
      } else {
        return '';
      }
    },
    makeImageUrl(template) {
      return this.api.makeImageUrlEditor(template.thumbnailImage);
    },
    onTemplate(template) {
      this.$router.push({
        name:'template',
        params:{
          templateId:template.id
        }
      });
      this.$ana.track({
        eventCategory:'template',
        eventAction:'changeTemplate',
        extra:{
          templateId:template.id
        }
      });
    }
  }

}
</script>
